import dataDE from './dataDE'
import dataEN from './dataEN'
import dataAZ from './dataAZ'
export default ({
    de: dataDE,
    en: dataEN,
    az: dataAZ
})